<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="headReturn" v-if="localStep == 0">
      <span @click="returnBack"> <i class="el-icon-arrow-left"></i> 返回列表</span>
      <span style="margin: 0 20px">|</span>
      <span class="name">{{ activityData.name }}</span>
    </div>

    <!-- 步骤条 -->
    <div class="step">
      <el-steps class="bz" :space="250" :active="localStep" finish-status="success" align-center>
        <el-step title="活动模板"></el-step>
        <el-step title="设置规则"></el-step>
        <el-step title="完成发布"></el-step>
      </el-steps>
    </div>
    <!-- 选中活动模板 -->
    <div class="firststep" v-if="localStep == 0">
      <div class="itemList">
        <div class="item">
          <div class="border"></div>
          <div class="wrapper">
            <img :src="activityData.telImg" alt="" />
            <div class="mask">
              <div class="img">
                <div class="imgBg">
                  <div id="queryId" ref="queryId"></div>
                  <!-- <img :src="activityData.telCode" alt="" /> -->
                </div>
                <span class="tpl">手机扫码预览模板</span>
                <!-- <div id="qrcode" ref="qrcode" class="qrcodeIcon"></div> -->
              </div>
              <div>
                <el-button type="primary" size="medium" @click="nextStep" style="width: 168px">下一步，设置活动内容</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  活动条件表单部分 -->
    <div class="secondstep" v-if="localStep != 0">
      <!-- <div class="secondstep" v-if="localStep == 1"> -->
      <div
        style="
          float: left;
          margin: -100px 0 0 10px;
          font-size: 16px;
          color: #2e3458;
          font-weight: bold;
        "
      >
        <span>邀请开卡</span>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="活动名称:" required>
          <!-- prop="activityName" 活动名称 -->
          <el-input v-model="ruleForm.activityName" maxlength="15" show-word-limit placeholder="积分任务的展示名称" style="width: 500px"></el-input>
        </el-form-item>

        <el-form-item label="活动时间:" required>
          <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="ruleForm.activityStartTime"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              default-time="00:00:00"
              class="time1"
              @change="activityTimeChange"
              :disabled="disableTime == true"
              :clearable="false"
              :picker-options="pickerOptionsStart"
            >
            </el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="ruleForm.activityEndTime"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              default-time="23:59:59"
              class="time2"
              @change="activityTimeChange"
              :clearable="false"
              :picker-options="pickerOptionsEnd"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime(ruleForm.activityStartTime, ruleForm.activityEndTime)"></i>
            <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
          </div>
          <span class="lastTime">
            活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天 <span style="color: #fe4d45">{{ timeOut }}</span> 小时
            <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="right-start">
              <el-button type="text" style="margin-left: -30px">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </span>
        </el-form-item>

        <el-form-item label="活动参与对象:" prop="partner">
          <el-checkbox-group v-model="ruleForm.partner" @change="checkListchange">
            <el-checkbox label="-1" name="partner">全部</el-checkbox>
            <el-checkbox label="0" name="partner" :disabled="ruleForm.partner == -1">非会员</el-checkbox>

            <el-checkbox v-for="(item, index) in levelList" :key="index" :label="index + 1 + ''" name="partner" :disabled="ruleForm.partner == -1">{{
              item
            }}</el-checkbox>
          </el-checkbox-group>
          <span v-if="localStepNum == 3">注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span>
        </el-form-item>

        <el-form-item label="奖品设置:" prop="setPrize">
          <el-radio v-model="ruleForm.isCumulativePrize" :label="false">统一奖品</el-radio>
          <el-radio v-model="ruleForm.isCumulativePrize" :label="true">梯度奖品</el-radio>
          <div class="prize_box">
            <template v-if="!ruleForm.isCumulativePrize">
              <div style="margin-bottom:10px" class="line">
                <div>每邀请一人可得</div>
                <div v-if="prizeSettingList.prizeType != 3" style="color:#FE4D45;margin:0 10px">
                  {{ prizeSettingList.prizeTxt }}{{ prizeSettingList.prizeType | prizeType }}
                </div>
                <div v-else style="color:#FE4D45;margin:0 10px">{{ prizeSettingList.title }}</div>
                <div>，活动期间最多邀请</div>
                <el-input v-model="ruleForm.peopleCount" style="width: 70px;margin:0 10px" oninput="value=value.replace(/^0|[^\d]/g,'')">
                  <!-- @input.native="checkputn" -->
                </el-input>
                <div>人，超出人数不再获得奖励</div>
                <el-tooltip class="item" effect="light" content="以成功邀请开卡的人数为准" placement="right-start">
                  <el-button type="text" style="margin-left: -30px">
                    <i style="color: #ccc;" class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </div>
              <div style="margin-bottom:20px" class="line">
                <div>奖品总份数：</div>

                <el-input v-model="ruleForm.prizeCount" oninput="value=value.replace(/^0|[^\d]/g,'')" style="width: 70px;margin:0 10px"></el-input>
                <div>份</div>
              </div>
              <el-button @click="centerVis">选择奖品</el-button>
              <div class="theLag" v-if="prizeSettingList.prizeType">
                <div class="theBox">
                  <div v-if="prizeSettingList.prizeType != 3" class="flex" style="margin: 30px 0 15px 0; width: 280px;justify-content: center;">
                    <div class="price_sty">{{ prizeSettingList.prizeTxt }}</div>
                    <div style="height:44px; width:1px;background:#FE4D45;opacity: .2;margin:0 12px"></div>
                    <div style="color:#999999">{{ prizeSettingList.prizeType | prizeType }}</div>
                  </div>
                  <p v-else style="margin: 30px 0 25px 0; width: 280px; text-align: center">
                    {{ prizeSettingList.title }}
                  </p>
                  <p class="pp">{{ prizeSettingList.prizeType | prizeType }}</p>
                </div>
                <div class="backgrd"></div>
                <el-button class="btnQx" type="primary" @click="deleteCoupon">删除</el-button>
              </div>
            </template>
            <template v-else>
              <div class="tips">
                <img
                  src="@/assets/images/new_icon_waring_yellow.png"
                  style="
                      margin-right:6px;
                      position: relative;
                      width: 14px;
                      height: 14px;
                      color: #FFB95E;
                    "
                />
                <span>温馨提示</span>
                <p>
                  规则：达到邀请人数的最大人数并领取奖品后，可继续邀请开卡但是不能获得奖品
                </p>
              </div>
              <el-table
                :header-cell-style="{ 'text-align': 'center', 'border-bottom': '2px solid #EBEEF5' }"
                :cell-style="{ 'text-align': 'center', overflow: 'visible' }"
                :data="tableData"
                border
                style="width: 625px;overflow: visible;"
              >
                <el-table-column prop="date" label="邀请人数" width="110">
                  <template slot-scope="scope">
                    <el-input @keyup.native="limitInput($event)" v-model="scope.row.peopleCount"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="奖品类型">
                  <template slot-scope="scope">
                    <span style="color:#7F85E9;cursor: pointer;" v-if="scope.row.prizeType == 3" @click="centerVis(scope)">{{
                      scope.row.title
                    }}</span>
                    <span style="color:#7F85E9;cursor: pointer;" v-else-if="scope.row.prizeType" @click="centerVis(scope)">{{
                      scope.row.prizeType | prizeType
                    }}</span>
                    <span v-else @click="centerVis(scope)" style="color:#FE4D45;cursor: pointer;">选择奖品</span>
                  </template>
                </el-table-column>
                <el-table-column prop="price" width="110" label="值"> </el-table-column>
                <el-table-column prop="address" width="145" label="奖品总份数">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.prizeCount"></el-input>
                    <div class="del_box">
                      <div class="delQx" @click="itemDel(scope.$index)">
                        <img src="@/assets/images/btn_del.svg" alt="" />
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div @click="addPrizeRule" class="add_btn">
                <img style="width:24px" src="../../assets/images/btn_添加.svg" alt="" />
                添加条件
              </div>
            </template>
          </div>
        </el-form-item>

        <el-form-item label="曝光商品:" prop="exposure">
          <el-checkbox v-model="ruleForm.exposureSwitch">
            是否添加曝光商品
          </el-checkbox>
          <el-button style="width: 155px; margin: 0 15px" @click="exposureProducts" :disabled="ruleForm.exposureSwitch == false">
            {{ itemListFor.length != "" ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")" : "添加曝光商品" }}
          </el-button>
          <el-radio-group v-model="ruleForm.radio" :disabled="ruleForm.exposureSwitch == false">
            <el-radio :label="0">显示京东价</el-radio>
            <el-radio :label="1">显示促销价</el-radio>
          </el-radio-group>
          <draggable
            v-if="ruleForm.exposureSwitch == true"
            v-model="mainImagelist"
            chosen-class="chosen"
            :scroll="true"
            animation="150"
            force-fallback="true"
            @start="isDragging = true"
            @end="onEnd"
            style="margin-top: 10px"
          >
            <transition-group type="transition">
              <div v-for="(item, index) in mainImagelist" :key="item.skuId" style="display: inline-block; position: relative" class="show_upImg2">
                <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                <div @click.stop="delec(index)" class="delectPosible">
                  <i class="el-icon-circle-close" style="font-size: 16px"></i>
                </div>
              </div>
            </transition-group>
          </draggable>
        </el-form-item>
        <el-form-item label="活动规则:" required>
          <div
            style="
              width: 500px;
              backgroundcolor: rgba(250, 250, 250, 1);
              padding: 8px;
              position: relative;
            "
          >
            <el-input
              type="textarea"
              class="textarea"
              style="width: 484px"
              resize="none"
              v-model="ruleForm.activityRulesText"
              :maxlength="2000"
            ></el-input>
            <div class="prosi" style="color: #909399">
              （{{ ruleForm.activityRulesText.length ? ruleForm.activityRulesText.length - 1 : 0 }}/2000）
            </div>
            <div>
              <el-button type="primary" class="generate" plain @click="generateRule">
                生成规则
              </el-button>

              <span class="desc">
                <i class="el-alert__icon el-icon-info"></i>
                点击按钮自动生成规则，也可以自己编辑信息
              </span>
            </div>
          </div>
        </el-form-item>
        <el-form-item style="margin: 0 0 20px 0; text-align: center">
          <el-button
            v-show="!itemId"
            class="returnBtn"
            size="medium"
            @click="
              localStep = 0;
              localStepNum = 0;
            "
            >返回上一步</el-button
          >
          <el-button v-show="!itemId" class="keepBtn" type="primary" size="medium" @click="saveEdit" v-preventReClick>保存并完成设置</el-button>
          <el-button v-show="itemId" class="returnBtn" size="medium" @click="cancelEdit">取消</el-button>
          <el-button v-show="itemId" class="keepBtn" type="primary" size="medium">保存并完成设置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
    ></selectGoodsMonitor>
    <!-- :skuSearch="true" -->
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
        <el-button @click="joinBlackList = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct :putPrize="putPrize" @close="colseDialog" v-if="showDialog" ref="selectProduct" @choose-shop="getTheData"> </selectProduct>
  </div>
</template>

<script>
import {
  invite,
  editInvite,
  searchInvite,
  follow,
  editfollow,
  searchfollow,
  information,
  editInformationAa,
  searchInformation,
  creatPrize,
  editPrize,
  searchPrize,
} from "@/api/integralCenter/integralTask";
import { jingdouList, allAccountList, redPacketList } from "@/api/integralCenter/prizeCenter.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
// import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
const prizeName = ["", "", "京豆", "实物", "店铺积分", "京东E卡", "爱奇艺会员", "京东PLUS会员", "现金红包"];
export default {
  components: {
    selectProduct,
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
  },
  created() {
    if (this.activeValue == 5) {
      //邀请开卡
      searchInvite({ id: this.valueRow.id }).then((res) => {
        this.ruleForm.isCumulativePrize = res.data.ruleDto.isCumulativePrize;
        if (res.data.ruleDto.isCumulativePrize) {
          this.tableData = res.data.ruleDto.cumulativePrizes.map((item, index) => {
            let obj = {
              peopleCount: item.cumulativeNum,
              title: item.cumulativePrizeDTO.title,
              assetsId: item.cumulativePrizeDTO.assetsId,
              prizeType: item.cumulativePrizeDTO.prizeType,
              logo: item.cumulativePrizeDTO.logo,
              price: item.cumulativePrizeDTO.price || item.cumulativePrizeDTO.singleAmount,
              singleAmount: item.cumulativePrizeDTO.singleAmount,
              prizeCount: item.cumulativePrizeDTO.totalAmount,
            };
            return obj;
          });
          console.log(this.tableData);
        } else {
          let prize = res.data.ruleDto.cumulativePrizes;
          console.log(prize[0]);
          this.ruleForm.prizeCount = prize[0].cumulativePrizeDTO.totalAmount;
          this.prizeSettingList = {
            singleAmount: prize[0].cumulativePrizeDTO.singleAmount,
            title: prize[0].cumulativePrizeDTO.title,
            assetsId: prize[0].cumulativePrizeDTO.assetsId,
            prizeType: prize[0].cumulativePrizeDTO.prizeType,
            logo: prize[0].cumulativePrizeDTO.logo,
            price: prize[0].cumulativePrizeDTO.price,
            discount: prize[0].cumulativePrizeDTO.singleAmount,
          };
          this.setPrizeTxt(this.prizeSettingList);
          this.ruleForm.peopleCount = res.data.ruleDto.maxInviteNum || "";
        }

        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        this.selectGoodsArr = res.data.itemList;
        this.itemListFor = res.data.itemList;
        this.mainImagelist = res.data.itemList;
        this.ruleForm.radio = res.data.priceType;
        this.activityTimeChange();
      });
    }
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      }
      return result;
    },
  },
  mounted() {
    this.getLevel();
    this.$nextTick(() => {
      this.qrcodeAll(this.activityData.telCode, queryId);
    });
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    console.log(this.activeValue, 99996);
  },
  data() {
    return {
      levelList: [],
      disableTime: false,
      clickActual: true,
      qrcode: null,
      order: "",
      showDialog: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        price: "",
        singleAmount: "",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            return time.getTime() < new Date(this.ruleForm.activityStartTime).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return time.getTime() > new Date(this.ruleForm.activityEndTime).getTime();
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      localStep: this.stepNum,
      localStepNum: this.activityData.id,
      activityStartTime: null,
      activityEndTime: null,
      putPrize: {},
      ruleForm: {
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
      },
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        activityRulesText: [{ required: true, message: "请填写活动规则", trigger: "blur" }],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
    };
  },
  watch: {
    localStepNum(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.qrcodeAll(this.activityData.telCode, queryId);
        });
      }
    },
  },
  methods: {
    limitInput(event) {
      if (event.target.value == "0") {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, "");
      }
    },
    itemDel(index) {
      if (this.tableData.length == 1) {
        this.$message.warning("梯度奖品必须有一个奖项");
        return;
      }
      this.tableData.splice(index, 1);
      console.log(this.tableData);
      // delete this
    },
    addPrizeRule() {
      this.tableData.push({
        peopleCount: "",
        prizeType: "",
        value: "",
        prizeCount: "",
      });
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = true;
      console.log("clickActual", this.clickActual);
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      console.log(filtered, e.target.value, this.ruleForm.peopleCount);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    //选择商品数据
    getTheData(data, prizeType) {
      console.log(data, prizeType, "data");
      this.colseDialog();
      this.showDialog = false;
      console.log(this.tableIndex);

      // v3.4邀请开卡
      /**
       * @param singleAmount 积分数，京豆数  其余奖项为1
       */
      // 梯度奖励
      if (this.ruleForm.isCumulativePrize == true) {
        this.tableData[this.tableIndex].prizeType = prizeType;
        this.tableData[this.tableIndex].price = data.discount || data.singleAmount;
        this.tableData[this.tableIndex].singleAmount = data.singleAmount;
        this.tableData[this.tableIndex].title = data.name || prizeType;
        this.tableData[this.tableIndex].assetsId = Number(data.couponId);
        this.tableData[this.tableIndex].logo = data.logo;
      } else {
        this.prizeSettingList.singleAmount = 1;
        this.prizeSettingList.assetsId = Number(data.couponId);
        this.prizeSettingList.prizeType = prizeType;
        this.prizeSettingList.logo = data.logo;
        this.prizeSettingList.title = data.name || prizeType;
        this.prizeSettingList.price = data.discount;
        if (prizeType == 4) {
          this.prizeSettingList.title = prizeType;
          this.prizeSettingList.price = data.discount;
          this.prizeSettingList.singleAmount = data.singleAmount;
        } else if (prizeType == 2) {
          this.prizeSettingList.singleAmount = data.singleAmount;
          this.prizeSettingList.couponType = data.couponType;
          this.prizeSettingList.title = prizeType;
        }
        this.setPrizeTxt(this.prizeSettingList);
        console.log(this.prizeSettingList);
      }
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else if (item.prizeType == 7 || item.prizeType == 6 || item.prizeType == 5) {
        item.prizeTxt = item.price;
      } else {
        item.prizeTxt = item.singleAmount;
      }
    },
    //模板下一步
    nextStep() {
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
    },
    //弹框确认
    handleDialogCloseAnoth() {
      console.log(this.prizeSettingList, 222222);
      // console.log(this.ruleForm.startTime,2222222);
      // this.$emit("fromChild", 2);
      //日历签到
      let everyDay = {
        activityName: this.ruleForm.activityName, //活动名称
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级
        condFollow: this.ruleForm.isFollow == true ? 1 : 0, //参与条件
        endTime: this.ruleForm.activityEndTime, //活动结束时间
        isExposureItem: this.ruleForm.exposureSwitch == false ? 0 : 1, //是否曝光商品：0否,1是
        itemList: this.itemListFor, //曝光商品集合
        points: Number(this.ruleForm.inputprize), //单次奖励积分
        priceType: this.ruleForm.radio, //曝光商品价格显示：0显示京东价，1显示促销价
        pointActivityPrizeDTO: {
          //选择奖品数据
          price: this.prizeSettingList.price,
          title: this.prizeSettingList.title,
          assetsId: this.prizeSettingList.assetsId,
          prizeType: this.prizeSettingList.prizeType,
          logo: this.prizeSettingList.logo,
          couponType: this.prizeSettingList.couponType,
        },
        ruleDTO: {
          //规则拓展信息
          continueRule: this.itemArr,
          requestFollow: this.ruleForm.isFollow, //是否关注
          startTime: this.ruleForm.startTime,
          prizeCount: Number(this.ruleForm.prizeCount),
        },
        ruleDescription: this.ruleForm.activityRulesText, //规则拓展信息
        startTime: this.ruleForm.activityStartTime, //活动开始时间
      };
      //编辑回显
      this.momentValue = everyDay;
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            if (obj.wareId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                wareId: obj.wareId,
              });
            }
          });
        }
        everyDay.itemList = b;
      }
      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }
      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        //通过活动来调取不一样的接口
        if (this.activityData.name == "邀请开卡") {
          everyDay.ruleDTO = {};
          // 接口需要，points固定传个正数
          everyDay.points = 1;

          everyDay.ruleDTO.maxInviteNum = this.ruleForm.peopleCount;
          everyDay.ruleDTO.isCumulativePrize = this.ruleForm.isCumulativePrize;
          delete everyDay.pointActivityPrizeDTO;
          // 梯度奖励
          if (this.ruleForm.isCumulativePrize) {
            everyDay.ruleDTO.cumulativePrizes = this.tableData.map((item) => {
              let prize = {
                title: item.title,
                assetsId: item.assetsId,
                prizeType: item.prizeType,
                singleAmount: item.singleAmount,
                totalAmount: item.prizeCount,
              };
              if (prize.prizeType == 3) {
                prize.logo = item.logo;
              }
              if (prize.prizeType != 2 && prize.prizeType != 4) {
                console.log(item.price);
                prize.price = item.price;
              }
              return {
                cumulativeNum: item.peopleCount,
                cumulativePrizeDTO: prize,
              };
            });
            everyDay.ruleDTO.maxInviteNum = this.tableData[this.tableData.length - 1].peopleCount;
            console.log(everyDay.ruleDTO.cumulativePrizes);
          } else {
            let prize = {
              title: this.prizeSettingList.title,
              assetsId: this.prizeSettingList.assetsId,
              prizeType: this.prizeSettingList.prizeType,
              logo: this.prizeSettingList.logo,
              singleAmount: this.prizeSettingList.singleAmount,
              totalAmount: this.ruleForm.prizeCount,
            };
            if (prize.prizeType == 3) {
              prize.logo = this.prizeSettingList.logo;
            }
            if (prize.prizeType != 2 && prize.prizeType != 4) {
              prize.price = this.prizeSettingList.price;
            }

            everyDay.ruleDTO.cumulativePrizes = [
              {
                cumulativeNum: 1,
                cumulativePrizeDTO: prize,
              },
            ];

            console.log(this.prizeSettingList, 123);
          }

          // 编辑
          if (this.activeValue == 5) {
            everyDay.pointActivityId = this.valueRow.id;
            editInvite(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  this.$emit("saveEdit");
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          } else {
            invite(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  this.$emit("saveEdit");
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          }
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    // 检查奖品总数
    async checkedPrizeCount(item) {
      // const typeArr = ['','','jingdouList','3','4','allAccountList','allAccountList','allAccountList','redPacketList']
      await this.setPromise(item);

      // console.log(res);
      // res.filter(i=>{
      //   if (i==item.priceType) {

      //   }
      // })
    },
    setPromise(item) {
      if (item.priceType == 2) {
        return new Promise((resolve, reject) => {
          const formLitJD = {
            current: 1,
            size: 100,
            isFilterUsed: true,
            status: 2,
          };
          jingdouList(formLitJD)
            .then((res) => {
              res.filter((i) => {
                // 对应的计划
                if (i.id == item.assetsId) {
                  // 奖品总份数为空
                  if (!item.totalAmount) {
                  }
                }
              });
              resolve(res);
            })
            .catch((res) => {});
        });
      }
    },
    // getJingdouList() {
    //   jingdouList(this.formLitJD)
    //     .then((res) => {
    //       let selectArr = res.data.records.map((item) => {
    //         return {
    //           label: item.planName,
    //           value: item.id,
    //         };
    //       });
    //       this.selectList = selectArr;
    //       this.planList.jingdou = res.data.records
    //     })
    //     .catch((res) => {});
    // },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },
    //完善信息删除
    deleteaInfo(index) {
      this.itemArrOne.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        arr.push(item.wareId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    centerVis(scope) {
      console.log(scope.$index);
      // 梯度奖品
      if (scope.$index || scope.$index == 0) {
        this.tableIndex = scope.$index;
        // 点击到已选实物奖品的条件，不置灰实物tab
        console.log(this.tableData[scope.$index].prizeType);
        if (this.tableData[scope.$index].prizeType == 3) {
          this.clickActual = false;
        }
      }

      if (this.isCumulativePrize) {
        this.putPrize = this.tableData[this.tableIndex];
      } else {
        this.putPrize = this.prizeSettingList;
      }
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
    },
    //连续签到删除
    deletea(index) {
      this.itemArr.splice(index, 1);
    },
    //添加条件
    addCondition() {
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.ruleForm.activityEndTime = null;
        return;
      }
      if (start < nowTime) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          this.$message.warning("开始时间不能小于当前时间");
          // this.ruleForm.activityStartTime = null;
          // return;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.activityEndTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.ruleForm.activityEndTime = null;
        return;
      }
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime != "" && this.ruleForm.activityStartTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 = new Date(this.ruleForm.activityEndTime).getTime() - new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
      if (
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityEndTime.substring(0, 10) == this.ruleForm.activityStartTime.substring(0, 10)
      ) {
        this.$message.warning("活动时间不能小于一天");
        this.ruleForm.activityEndTime = "";
      }
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      // console.log(this.ruleForm.isCumulativePrize);
      let state = true;
      if (this.ruleForm.isCumulativePrize) {
        let arr = this.tableData.map((i) => {
          return i.peopleCount;
        });
        if (arr.indexOf("") != -1) {
          return this.$message.error("邀请人数不可为空");
        }
        var flagSort = false;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i + 1]) {
            if (Number(arr[i]) >= Number(arr[i + 1])) {
              flagSort = true;
              break;
            }
          }
        }
        if (flagSort) {
          return this.$message.error("邀请人数梯度不可小于或等于上一个梯度");
        }

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (this.tableData[index].prizeType == "") {
            return this.$message.error("请在条件中设置奖品");
          }
          for (let indexSecond = index; indexSecond < arr.length; indexSecond++) {
            console.log(element, arr[indexSecond], element > arr[indexSecond]);
            if (Number(element) > Number(arr[indexSecond])) {
              state = false;
            }
          }
        }
        if (!state) {
          return this.$message.error("邀请人数梯度不可小于上一个梯度");
        }
      }
      // console.log(this.ruleForm.informationOne);
      // console.log(this.itemArrOne);
      this.joinBlackList = true;
      // this.$emit("saveEdit");
    },
    // 下一步
    resetForm() {
      this.joinBlackList = true;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // debugger
      this.$refs.selectGo.handleRightCurrentChange(1);
      // console.log(this.selectGoodsArr);
      // return
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(data) {
      console.log(data);
      // debugger
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text2 = "活动时间：" + this.ruleForm.activityStartTime + "~" + this.ruleForm.activityEndTime;
      }
      //参与对象
      if (this.ruleForm.partner.length > 0) {
        let levelText = [];
        this.ruleForm.partner.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });

        text4 = "活动参与对象：" + levelText.splice(",");
      }

      if (this.activityData.name == "邀请开卡") {
        console.log(this.ruleForm);
        if (!this.ruleForm.isCumulativePrize) {
          let prizeText = this.prizeSettingList.singleAmount + prizeName[this.prizeSettingList.prizeType];
          if (this.prizeSettingList.prizeType == 3) {
            prizeText = this.prizeSettingList.title;
          } else {
            prizeText = this.prizeSettingList.prizeTxt + prizeName[this.prizeSettingList.prizeType];
          }
          text6 = "奖品设置：" + "每邀请一人可获得" + prizeText + ",";

          if (this.ruleForm.peopleCount) {
            text6 += "活动期间最多邀请" + this.ruleForm.peopleCount + "人" + "," + "超出人数不再获得奖励";
          }
        } else {
          console.log(this.tableData);
          let textArr = this.tableData.map((i) => {
            let prizeText = i.prizeType == 3 ? i.title : i.price + "" + prizeName[i.prizeType];
            let str = `邀请${i.peopleCount}人可获得${prizeText}`;
            return str;
          });
          console.log(textArr);
          text6 = "奖品设置：" + textArr.join("，") + "，超出人数不再获得奖励";
        }
      }
      let levetList = [];
      let levetListOne = [];
      let levetListTwo = "";
      let levetListThree = "";
      this.ruleForm.information.forEach((o, x) => {
        if (o == -1) {
          o = "全部";
        }
        levetListOne.push(o);
      });
      this.itemArrOne.forEach((v, i) => {
        levetList.push(v.informationmationOne);
      });
      levetListTwo = levetListOne.join(",");
      levetListThree = levetList.join(",");
      if (levetListTwo.length != "" && levetListThree.length == 1) {
        levetListThree = "";
      }
      if (levetListTwo.length != "" && levetListThree.length > 1) {
        levetListTwo = levetListOne.join(",") + ",";
      }
      text7 = "分享给好友后，需要好友点击进入并开卡成功才算邀请成功";
      text8 = "奖品数量有限，先到先得";
      text9 = "如果被邀请人在邀请过程中开过店铺会员或品牌会员的卡，需要重新回到被邀请人页面，邀请人才能获得奖励！";
      let Arr1 = [text1, text2, text3, text4, text5, text6, text7, text8, text9];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__body-wrapper {
  overflow: visible !important;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.startTime {
  /deep/ .el-table__body-wrapper {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.delectPosible {
  position: absolute;
  top: -3px;
  right: 6px;
  color: red;
  cursor: pointer;
}
.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68);
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 625px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 82px;
      border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 40px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url(../../assets/images/integralCenter/yhq.png);
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .price_sty {
          font-family: DIN;
          font-weight: bold;
          color: #fe4d45;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      //   .btnQx {
      //     display: none;
      //   }
      //   &:hover {
      //     .btnQx {
      //       display: block;
      //       position: absolute;
      //       top: 50%;
      //       left: 50%;
      //       margin: -16px 0 0 -49px;
      //     }
      //     .backgrd {
      //       width: 280px;
      //       height: 120px;
      //       background: #fff;
      //       position: absolute;
      //       border-radius: 8px;
      //       opacity: 0.7;
      //     }
      //   }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .desc {
      i {
        opacity: 0.7;
        color: #fe4d45;
      }
      color: #999;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      transition: all 0.2s;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>

<style lang="scss">
.createPlayStep {
  .el-step__head.is-success {
    color: #fe4d45;
    border-color: #fe4d45;
    .el-step__line {
      background-color: #fe4d45;
    }
  }
  .el-step__head.is-process {
    color: #fe4d45;
    border-color: #fe4d45;
  }
  .el-step__title.is-process {
    color: #fe4d45;
  }
  .el-step__title.is-success {
    color: #fe4d45;
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
}
</style>
